import { ProductFeaturesComparisonFeature } from './services/productService';

export type ProductGroupPdpComparisonOwnProps = {
  actionId?: string;
  campaign?: string;
  colorId?: string;
  maxProductsSize?: number;
  productGroupFredhopperId?: string;
  productId: string;
  title?: string;
  productsFeaturesRecord: Record<number, Array<ProductFeaturesComparisonFeature> | undefined>;
  currentProductHasFeatures: boolean;
};
